import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { MapPin, ArrowRight } from "lucide-react";
import Seo from "../components/Seo";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      setDone(true);
      toast.success("Message sent.");
    } catch {
      toast.error("Failed to send. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="contact-page">
      <Seo title="Contact" description="Contact B7 Search & Selection — Dubai HQ, serving UK, Europe and the Middle East." path="/contact" />

      <section className="max-w-7xl mx-auto px-6 sm:px-10 pt-32 pb-12">
        <div className="overline">Contact</div>
        <h1 className="font-serif text-5xl sm:text-7xl mt-6 leading-[0.95] tracking-tight" data-testid="contact-headline">
          Let's <span className="italic text-[#1E2A78]">talk</span>.
        </h1>
      </section>

      <section className="max-w-7xl mx-auto px-6 sm:px-10 pb-24 grid grid-cols-1 lg:grid-cols-12 gap-16">
        <div className="lg:col-span-5">
          <p className="text-lg leading-relaxed text-[#222]">
            Whether you're hiring or hunting — a B7 consultant is the right place to start.
          </p>

          <div className="mt-12 space-y-8">
            <div className="flex gap-4" data-testid="contact-address">
              <MapPin className="text-[#1E2A78] shrink-0 mt-1" size={20} />
              <div>
                <div className="overline">Headquarters</div>
                <p className="mt-2 text-[#222] leading-relaxed">
                  Tameem House, Al Barsha Heights<br />Dubai, United Arab Emirates
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          {done ? (
            <div className="border border-[#E2E0D9] bg-white p-12" data-testid="contact-success-message">
              <div className="overline">Sent</div>
              <h2 className="font-serif text-3xl mt-4">Message received.</h2>
              <p className="text-[#5C5C5C] mt-4">A consultant will respond shortly.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-8" data-testid="contact-form">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <input className="field" placeholder="Name *" required value={form.name} onChange={update("name")} data-testid="contact-name-input" />
                <input className="field" placeholder="Email *" type="email" required value={form.email} onChange={update("email")} data-testid="contact-email-input" />
                <input className="field" placeholder="Phone" value={form.phone} onChange={update("phone")} data-testid="contact-phone-input" />
                <input className="field" placeholder="Subject" value={form.subject} onChange={update("subject")} data-testid="contact-subject-input" />
              </div>
              <textarea className="field" placeholder="Message *" required value={form.message} onChange={update("message")} data-testid="contact-message-input" />
              <button type="submit" disabled={loading} className="btn-primary" data-testid="contact-submit-button">
                {loading ? "Sending..." : "Send message"} <ArrowRight size={16} />
              </button>
            </form>
          )}
        </div>
      </section>
    </div>
  );
}
